import React from 'react'
const ListSpan = (props) => {
    return ( 
        <>
        <div className="d-flex flex-stack">
            <div className="d-flex">
                <div className="d-flex flex-column">
                    <span className="fs-5 text-gray-900 text-hover-primary fw-bold">{props.text}</span>
                    <div className="fs-6 fw-semibold text-gray-500">{props.subtext}</div>
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <div className="form-check form-check-solid form-check-custom form-switch">
                    <input className="form-check-input w-45px h-30px" type="checkbox" checked={props.value} onChange={props.onChange} />
                    <label className="form-check-label" />
                </div>
            </div>
        </div>
        <div className="separator separator-dashed my-5"></div>
     {/*   <li className="list-group-item">
          {props.value ? 
            <span className="text-success">
                <i className='bi bi-check-circle-fill'></i> {props.text}
            </span>
            :
            <span className="text-danger">
                    <i className='bi bi-x-circle-fill'></i> {props.text}
            </span>
            }
            </li>
        */}
        </>
      
     );
}
 
export default ListSpan;